import state from './moduleBackgroundTaskManagerState.js'
import mutations from './moduleBackgroundTaskManagerMutations.js'
import actions from './moduleBackgroundTaskManagerActions.js'
import getters from './moduleBackgroundTaskManagerGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
